import { render, staticRenderFns } from "./commonareas.vue?vue&type=template&id=37428b1e&scoped=true"
import script from "./commonareas.vue?vue&type=script&lang=js"
export * from "./commonareas.vue?vue&type=script&lang=js"
import style0 from "./commonareas.vue?vue&type=style&index=0&id=37428b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37428b1e",
  null
  
)

export default component.exports